import baseApi from '../utils/ApiUtils';

/**
 * Users api
 * */
export const usersAPi = (method, params = null, payload = null) => {
  return baseApi(`/users/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const usersActionServices = (method, id, params = null, payload = null) => {
  return baseApi(`/users/${id}/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const usersProfileAPi = (method, params = null, payload = null) => {
  return baseApi(`/users/profile/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const userProfileUploads = (method, id, params = null, payload = null) => {
  return baseApi(`/users/${id}/upload_photo`, method, params, payload).then(response => {
    return response.data;
  });
};

export const rolesAPi = (method, params = null, payload = null) => {
  return baseApi(`/roles/`, method, params, payload).then(response => {
    return response.data;
  });
};
